export default {
  form: {
    font_family: {
      label: 'Fontti',
    },
    header: {
      label: 'Otsikko',
      placeholder: 'Otsikko',
    },
    sub_header: {
      label: 'Alaotsikko',
      placeholder: 'Alaotsikko',
    },
    qr_code_header: {
      label: 'Infolaatikon otsikko',
      placeholder: 'Infolaatikon otsikko',
    },
    qr_code_description: {
      label: 'Infolaatikon kuvaus',
      placeholder: 'Infolaatikon kuvaus',
    },
    footer: {
      label: 'Alatunnisteen teksti',
      placeholder: 'Kirjoita alatunnisteen teksti',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Valitse URL',
    },
    url: {
      placeholder: 'www.esimerkki.fi',
    },
    primary_color: {
      label: 'Pääväri',
    },
    background_color: {
      label: 'Taustaväri',
    },
    cover_image: {
      label: 'Kansikuva',
    },
    logo: {
      label: 'Logo',
    },
    logo_zoom: {
      label: 'Logon zoomaus',
    },
  },
  toasts: {
    failed_to_load_data: 'Ovitarran lataaminen epäonnistui',
  },
};
